import axios from 'axios';
import authHeader from './auth-header';
const DOMAIN_NAME = process.env.REACT_APP_DOMAIN_NAME || "http://localhost:9000";
const cleanDomain = DOMAIN_NAME.replace(/\/+$/, "");
const API_URL = cleanDomain + "/api/test/";

var browserDomain = API_URL;

try {
  if (window.location.protocol === 'https:') {
    browserDomain = API_URL;
  } else {
    const url = new URL(window.location.href);
    const setDomain = new URL(cleanDomain);

    if (url.hostname !== setDomain.hostname) {
      const port = setDomain.port ? `:${setDomain.port}` : '';
      browserDomain = `${url.protocol}//${url.hostname}${port}/api/test/`;
    } else {
      browserDomain = API_URL;
    }
  }
} catch (e) {
  browserDomain = API_URL;
}

class UserService {
  getPublicContent() {
    return axios.get(browserDomain + 'all');
  }

  getUserBoard() {
    return axios.get(browserDomain + 'user', { headers: authHeader() });
  }

  getAdminOrMasterBoard() {
    return axios.get(browserDomain + 'admin-master', { headers: authHeader() });
  }

  getUnauthorizedBoard() {
    return axios.get(browserDomain + 'unauthorized-user', { headers: authHeader() });
  }
}

const userServiceInstance = new UserService();
export default userServiceInstance;